import { Select, Tooltip, Tag, Checkbox, Divider } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import React, { useState, useEffect } from "react";

const CustomSelect = ({
  options,
  handleSelection,
  handleCancel,
  defaultValue = [],
  ...props
}) => {
  const [value, setValue] = useState(defaultValue);

  // Sort options to show selected items at the top
  const [sortedOptions, setSortedOptions] = useState([]);

  useEffect(() => {
    const selected = options.filter((opt) => value.includes(opt.id));
    const notSelected = options.filter((opt) => !value.includes(opt.id));
    setSortedOptions([...selected, ...notSelected]);
  }, []);

  const tagRender = (props) => {
    const { label, closable, onClose } = props;
    return (
      <Tag
        closable
        color="#CDD4E0" //background color
        onClose={onClose}
        style={{
          marginRight: 3,
          borderRadius: 4,
          color: "#0058be",
          fontWeight: "bold",
          padding: "2px 8px",
        }}
        closeIcon={
          <CloseOutlined
            style={{ color: "#0058be", fontSize: "12px", marginLeft: 5 }}
          />
        }
      >
        {label}
      </Tag>
    );
  };
  const allOptionValues = options
    .filter((opt) => !opt.disabled)
    .map((opt) => opt.id);

  const handleSelectAll = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setValue(allOptionValues);
    handleSelection(allOptionValues);
  };

  const handleClearAll = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setValue([]);
    handleSelection([]);
  };

  return (
    <div className="custom-select-wrapper">
      <Select
        mode="multiple"
        className="custom-select"
        placeholder="Search Organizations"
        value={value}
        tagRender={tagRender}
        onChange={(selectedValues) => {
          setValue(selectedValues);
          handleSelection(selectedValues);
        }}
        options={sortedOptions.map((opt) => ({
          label: (
            <Tooltip title={opt.disabled ? "Assessment not initiated" : ""}>
              {opt.option}
            </Tooltip>
          ),
          value: opt.id,
          disabled: opt.disabled,
        }))}
        getPopupContainer={(trigger) => trigger.parentNode} //positioning
        autoFocus
        open
        onBlur={(event) => {
          const relatedElement = event.relatedTarget;
          if (
            relatedElement &&
            relatedElement.classList.contains("dropdown-actions")
          ) {
            return; //
          }
          handleCancel();
        }}
        filterOption={(input, option) =>
          option.label.props.children
            .toLowerCase()
            .includes(input.toLowerCase())
        }
        maxTagCount={props?.maxTagCount}
        minTagCount={props?.minTagCount}
        virtual={false}
        dropdownRender={(menu) => (
          <>
            {" "}
            {menu}
            <Divider style={{ margin: 0 }} />{" "}
            <div tabIndex={0} className="clear-all-option dropdown-actions">
              <div onClick={handleClearAll}>
                {" "}
                <CloseOutlined />
                CLEAR ALL
              </div>
              <div className="select-all-option" onClick={handleSelectAll}>
                SELECT ALL
              </div>
            </div>
          </>
        )}
      />
    </div>
  );
};

export default CustomSelect;
